var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Layout',{attrs:{"title":_vm.name,"hasQuickActionBar":false,"hasGlobalMenu":false,"breadcrumbs":_vm.pBreadcrumbs}},[_c('WorkflowDocumentDetail',{attrs:{"document":_vm.document,"loading":_vm.loading},on:{"refreshData":_vm.loadData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }